<template>
    <div>
        <b-overlay :show="isBusy" rounded="sm" spinner-variant="primary">
            <div class="form-group">
                <div class="form-check" v-for="(value, i) of options">
                    <input :id="'reason' + i" type="radio" v-model="reason" :value="value" class="form-check-input">
                    <label :for="'reason' + i" class="form-check-label">
                        {{ value }}
                    </label>
                </div>

                <div class="form-group" v-show="reason == 'Other'">
                    <label>Other:</label>
                    <input type="text" class="form-control" v-model="reason_other" :class="{ 'is-invalid': showOtherError }">
                    <div class="invalid-feedback" v-if="showOtherError">
                        Please provide a reason for cancellation
                    </div>
                </div>

                <div class="invalid-feedback d-block" v-if="showReasonError">
                    Please select a reason for cancellation before continuing
                </div>
            </div>

            <div class="d-flex">
                <a href="/billing" class="btn btn-primary btn-sm" :class="{ disabled: isBusy }" :tabindex="isBusy ? -1 : undefined" :aria-disabled="isBusy">No, take me back</a>
                <button @click="handleSubmit" class="ml-3 btn btn-primary btn-sm" :disabled="isBusy">Yes, I want to cancel</button>
            </div>
        </b-overlay>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                options: [
                    'Membership cost',
                    'Not enough content',
                    'I didn\'t like the content',
                    'The content was too advanced',
                    'The content was too basic',
                    'I chose another platform',
                    'Other',
                ],
                reason: null,
                reason_other: '',
                isBusy: false,
                showOtherError: false,
                showReasonError: false,
            }
        },

        methods: {
            // Form submission
            handleSubmit: function() {
                if (!this.reason) {
                    this.showReasonError = true;
                    return;
                }

                if (this.reason === 'Other' && !this.reason_other) {
                    this.showOtherError = true;
                    return;
                }
                
                this.showOtherError = false;
                this.showReasonError = false;
                this.isBusy = true;                

                let url = '/api/billing/cancel/feedback';

                axios({ 
                    method: 'post',
                    url: url,
                    data: {
                        'reason': this.reason,
                        'reason_other': this.reason_other,
                    },         
                })
                .then((response) => {
                    if(response.data) {
                        // We need to POST to the next step to prevent it being linked to
                        const form = document.createElement('form');
                        form.method = 'post';
                        form.action = '/billing/cancel/confirmed';

                        document.body.appendChild(form);
                        form.submit();
                    }
                }, (error) => {
                    if(error.response.data) {
                        this.errors = error.response.data.errors;
                        this.hasErrors = true;
                        this.isBusy = false;

                        window.scrollTo(0,0);
                    }
                });
            }
        }
    }
</script>